<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
               <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
                <el-select class="search_select search_inputBox" v-model="params.search.creator_id" multiple collapse-tags placeholder="制单人" @visible-change="getCreator">
                    <el-option v-for="(list,index) in selectMap.creater" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.search.order_return_sn" placeholder="退货单号"></el-input>
                <!-- <el-select class="search_select search_inputBox" v-model="params.search.brand_id" multiple collapse-tags placeholder="品牌">
                    <el-option v-for="list in brandList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.search.breed_id" multiple collapse-tags placeholder="品名">
                    <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.search.bale_no" placeholder="包号"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.search.warehouse_id" placeholder="仓库">
                    <el-option v-for="(list,index) in warehouseList" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <el-select class="search_select search_inputBox" v-model="params.search.status" placeholder="订单状态">
                    <el-option :value="999" :label="'全部状态'"></el-option>
                    <el-option :value="1" :label="'待审核'"></el-option>
                    <el-option :value="2" :label="'审核被拒绝'"></el-option>
                    <el-option :value="3" :label="'审核通过'"></el-option>
                    <el-option :value="4" :label="'退货完成'"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible;scene='return.list';isGlobal=false;filter=copy_filter;"></div>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',sell-return-review,')!=-1" @click="batch(1)">审核通过</el-button>
                <el-button class="funcPublicBtn" v-if="module.indexOf(',sell-return-review,')!=-1" @click="batch(2)">审核拒绝</el-button>
                <el-button class="funcPublicBtn" v-if="module.indexOf(',sell-return-review,')!=-1" @click="batchCancel">批量撤销</el-button>
                <el-button class="funcPublicBtn" v-if="module.indexOf(',sell-return-edit,')!=-1" @click="batchDel">批量删除</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="return.list"  :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @isCancel="isCancel" @getRow="getRow" @getTableDelete="getTableDelete" @rowClick="rowClick"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC threeLabel eldialogBack eldialogWidth" :modal="false" :title="'退货单'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="editPersonBox dialogForm editPersonBoxTop clearfix" style="display: flex;">
                    <div class="editPerson">客户：{{form_params.customer_name}}</div>
                    <div class="editPerson">退货单号：{{form_params.order_return_sn}}</div>
                    <div class="editPerson recMess">
                        <img src="/icon/operation_edits.png" v-if="isEdit==1" @click="amend" class="form_edits">
                        <div>REC：</div> 
                        <div class="recCom">
                            <el-checkbox :disabled="true" class="taxCheck" v-model="form_params.rec"></el-checkbox>
                            <div class="taxDiv" v-if="form_params.rec==true">
                                <el-select class="taxTypeSelect" placeholder="fx" :disabled="true" v-model="form_params.rec_type">
                                    <el-option :value="1" label="×"></el-option>
                                    <el-option :value="2" label="÷"></el-option>
                                </el-select>
                                <!-- <el-input class="taxInput" :disabled="true" v-model="form_params.tax_rate" v-digits:2="form_params.tax_rate" placeholder="税率" ></el-input>
                                <span class="taxSpan">%</span> -->
                                <el-input class="taxInput" :disabled="true" v-model="form_params.tax_rate" v-digits:2="form_params.tax_rate" placeholder="税率" >
                                        <template slot="suffix"><span class="sizefh">%</span></template>
                                </el-input>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterdetailsVisible=!filterdetailsVisible;"></div>
                </div>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="form_params.details" :summary-method="getTableSummaries" border stripe show-summary highlight-current-row size="mini" height="100%"  @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'sales_width_total'">
                                                    <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                        {{ scope.row.sales_width_total }}
                                                    </span>
                                            </div>
                                            <div v-else-if="item.field == 'return_width_total'">
                                                    <span @click="widthList = scope.row.return_width;returnDialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                        {{ scope.row.return_width_total }}
                                                    </span>
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table  :data="form_params.details" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="合同号" width="135" show-overflow-tooltip v-if="billColumn.indexOf(',contract_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.contract_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="供单号" width="65" show-overflow-tooltip v-if="billColumn.indexOf(',original_bale,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_bale }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="货权单位" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',opening_company,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.opening_company }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="仓库" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.warehouse }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="库位" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',storage_location,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.storage_location }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.sales_width_total }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售立方" prop="sales_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.sales_cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="出库立方" prop="out_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',out_cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.out_cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',return_pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.return_pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货立方" prop="return_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',return_cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.return_cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售单价" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_price,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.sales_price }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="退款金额(￥)" prop="return_amount" width="103" show-overflow-tooltip v-if="billColumn.indexOf(',return_amount,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.return_amount }}
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </div>
                    </div>
                    <div class="dialogTotal clearfix">
                        <div class="dialogTotalC">合计应退：</div>
                        <div class="dialogTotalC">退货金额:{{tableTotal.totalPrice}}</div>
                        <div class="dialogTotalC" v-if="form_params.rec==true&&Number(tableTotal.tax_amount)">税金:{{tableTotal.tax_amount}}</div>
                        <div class="dialogTotalC" v-if="Number(tableTotal.refundableAmount)">应退金额:{{tableTotal.refundableAmount}}</div>
                    </div>
                    <div class="remarkBox remarkBoxFourText">
                        <textarea class="remarkTextarea" readonly v-model="form_params.remark" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                    <div class="editPerson">销售人：{{form_params.salesman_name}}</div>
                    <div class="editPerson">退货时间：{{form_params.create_time | dateFormat_}}</div>
                </div>
                <div class="editBtnList clearfix">
                    <div style="float:left;margin-bottom: 10px;">
                        <el-button class="funcPublicBtnEdit" style="line-height: 25px;" v-if="isEdit==1" @click="openbusinessRelation">关联退货费用</el-button>
                        <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                                <img src="../../assets/top-delete-suspension.png" class="newFeeImg" v-if="isEdit==1" @click="isDeleteFee(list.id)"/>
                            </div>
                        </div>
                    </div>
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="centerDialogVisible=!centerDialogVisible;batchOrSingle=1">审核拒绝</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="pass([form_params.id])">审核通过</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
        <!--拒绝原因START-->
        <el-dialog v-dialog-drag title="拒绝原因" :visible.sync="centerDialogVisible" width="500px" class="eldialog eldialogA" :model="false">
            <textarea class="edit_input edit_textarea" v-model="refuse.refuse_remark" placeholder="请输入拒绝原因"></textarea>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn"  @click="confirmRefuseRemark">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="centerDialogVisible = false">取消</el-button>
            </div>
		</el-dialog>
        <!--拒绝原因END-->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="return.list" :isGlobal="isGlobal" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <filter-fields :tableData="filter" scene="return.details" :isGlobal="isGlobal" :filterDialogVisible="filterdetailsVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterdetailsVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!-- 退货宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="returnDialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :dialogvisible="returnDialogVisibleWidth" :list="widthList"  :type="4"  @cancelWidth="()=>{this.returnDialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 退货宽度列表END -->
        <!--REC START -->
        <el-dialog  v-dialog-drag title="税金修改" :visible.sync="recChanges"
                width="350px" class="eldialog" :model="false" custom-class="full_dialog">
            <el-form :model="rec_params" :inline="true" label-width="60px" class="demo-form-inline"
                size="mini">
                <el-form-item label="REC:" >
                    <el-checkbox class="taxCheck" v-model="f_rec" style="margin-right: 10px;"></el-checkbox>
                    <el-select class="formInput" style="width:60px" placeholder="fx" v-model="rec_params.rec_type">
                        <el-option :value="1" label="×"></el-option>
                        <el-option :value="2" label="÷"></el-option>
                    </el-select>
                    <el-input v-model="rec_params.tax_rate"  style="width:90px;" v-digits:2="rec_params.tax_rate" class="formInput tax_rate">
                    </el-input>
                    <span style="position: absolute;right: 5px;">%</span>
                </el-form-item>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn"  @click="settlementConfirm">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="outRecChanges()">取消</el-button>
            </div>
        </el-dialog>
        <!--REC END -->
        <!--添加费用START-->
        <el-dialog v-dialog-drag :visible.sync="businessRelation" class="eldialog eldialogLine" :modal="false" title="添加营业外支出费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="businessRelationForm" :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="businessRelationForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                     <el-form-item  label="销售单号：">
                        <el-input v-model="businessRelationForm.order_sn" readonly></el-input>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="businessRelationForm.fee_id" @input="outFeeChange" @visible-change="outFeeSelectFunc" clearable>
                            <el-option v-for="list in outFeeSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="businessRelationForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="金额(￥)：" prop="amount">
                        <el-input v-model="businessRelationForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="businessRelationForm.is_invoice">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="businessRelationForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="businessRelation=!businessRelation" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked"  @click="saveOutFee">确认</el-button> 
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加费用END-->
    </div>
</template>
<script>
    import bus from "../../eventBus";
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    import selectDownCustomer from '../../components/selectDownCustomer.vue'
    const initBusinessRelationForm = {
        order_id: "",
        order_sn: "",
        fee_date: "",
        fee_id: "",
        fee_name: "",
        payee: "",
        amount: "",
        is_invoice: "",
        remark: ""
    };
    const initRecParams = {
        id: "",
        rec:"", 
        tax_rate:"",
        rec_type:1,
    };
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                dialogVisibleWidth:false,
                returnDialogVisibleWidth:false,
                isGlobal:false,
                billColumn:"",
                scene:"",
                copy_filter:"",
                widthList:[],
                start_time:"",
                end_time:new Date(),
                params:{
                    search:{
                        start_time:"",
                        end_time:"",
                        customer_id:"",
                        order_return_sn:"",
                        brand_id:"",
                        breed_id:"",
                        creator_id:"",
                        bale_no:"",
                        warehouse_id:"",
                        status:"",
                    },
                    page:1,
                    per_page:50
                },
                dialogVisible:false,
                centerDialogVisible:false,
                filterDialogVisible:false,
                filterdetailsVisible:false,
                filter:"",
                filters: [],
                fields:"",
                refuse:{
                    ids:"",
                    refuse_remark:""
                },
                last_page:1,
                total:0,
                selectRow:[],
                form_params:{},
                selectionDetailRow:[],
                selectMap:{
                    customer:[],
                    creater:[]
                },
                list:[],
                tableCol:[
                    {colName:"退货单号",colKey:"order_return_sn",colWidth:190,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"退货日期",colKey:"return_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"状态",colKey:"status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"拒绝原因",colKey:"refuse_remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"销售单号",colKey:"order_sn",colWidth:140,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"客户名称",colKey:"customer_name",colWidth:170,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"片数",colKey:"sales_pieces",colWidth:50,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"销售立方",colKey:"sales_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"出库立方",colKey:"out_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"退货片数",colKey:"return_pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"退货方数",colKey:"return_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"销售金额",colKey:"sales_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"退款金额",colKey:"return_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"拒绝原因",colKey:"refuse_remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售人",colKey:"salesman_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"操作员",colKey:"operator_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"审核员",colKey:"auditor_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                totalObj:{},
                batchOrSingle:1 ,//1单条 2批量
                recChanges:false,
                rec_params: this.$cloneJson(initRecParams),
                f_rec:'',
                rec: "",
                tableTotal:{},
                newFee: [],
                businessRelation: false,
                businessRelationForm: this.$cloneJson(initBusinessRelationForm),
                feeOutFormRlues: {
                    fee_date: [{required: true, message: '请填写日期', trigger: 'blur'}],
                    order_id: [{required: true, message: '请选择销售单号', trigger: 'blur'}],
                    fee_id: [{required: true, message: '请选择费用名称', trigger: 'blur'}],
                    payee: [{required: true, message: '请填写收款人', trigger: 'blur'}],
                    amount: [{required: true, message: '请填写金额', trigger: 'blur'}],
                    is_invoice: [{required: true, message: '请选择是否开票', trigger: 'blur'}],
                },
                detailInfo: {},
                outFeeSelect: [],
                addId:0,
                isEdit:0,
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        methods:{
            headDrog(newWidth, oldWidth, column) {
                this.filters.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + 'return.details').replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            getCreator(){
                this.postFunc("/erp/return.creators",{},response=>{
                    this.selectMap.creater = response.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //打开
            openbusinessRelation(){
                this.businessRelationForm.order_id = this.form_params.id;
                this.businessRelationForm.order_sn = this.form_params.order_return_sn;
                this.businessRelation = true;
                this.businessRelationForm.fee_date = new Date();
            },
            outFeeChange(e){
                this.outFeeSelect.forEach(item=>{
                    if(item.id==e){
                        this.businessRelationForm.fee_name = item.name;
                    }
                })
            },
            //获取费用名称
            outFeeSelectFunc(){
                this.postFunc("/erp/purchase.cost.type",{type:2},res=>{
                    this.outFeeSelect=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            saveOutFee(){
                for(let key in this.businessRelationForm){
                    if(this.businessRelationForm[key]===""){
                        if(key!="remark"){
                            this.tip("请填写完整信息","warning")
                            return;
                        }
                    }
                }
                let time = this.businessRelationForm.fee_date;
                this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
                this.postFuncLoading("/erp/return.add.fee",this.businessRelationForm,res=>{
                    this.addId=res.data.data.id
                    this.newFee.push(JSON.parse(JSON.stringify(this.businessRelationForm)))
                    this.tip("添加成功", "success");
                    this.businessRelation=!this.businessRelation;
                },error=>{
                    this.businessRelationForm.fee_date = time;
                    this.tip(error.data.message,"warning")
                })
            },
            isDeleteFee(id){
                if(id){
                    id=id
                }else{
                    id=Number(this.addId)
                }
                this.postFunc("/erp/order.delete.fee",{fee_id:id},()=>{
                        // this.dialogVisible = false;
                        this.tip("删除成功","success")
                        // this.rowClick(this.refreshSale)
                })
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                this.filters = [];
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filter = response.data.data.columns;
                    this.filters = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    sales_cube:4,
                    out_cube:4,//出库立方
                    return_cube:4,
                    return_amount:2,
                },total=>{
                });
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            batchCancel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let arr = new Array();
                    for(let i=0;i<this.selectRow.length;i++){
                        if(this.selectRow[i].isCancel){
                            arr.push(this.selectRow[i].id)
                        }else{
                            this.tip("请选择数据有不可撤销项","warning")
                            return;
                        }
                    }
                    this.Cancel(arr)
                }
            },
            isCancel(id){
                this.$confirm('是否确认撤销?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let arr = new Array();
                    arr.push(id)
                    this.postFuncLoading("/erp/return.cancel",{ids:arr},()=>{
                        this.tip('撤销成功','success');
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            Cancel(ids){
                this.$confirm('是否确认撤销?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/return.cancel",{ids:ids},()=>{
                        this.tip('撤销成功','success');
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let arr = new Array();
                    for(let i=0;i<this.selectRow.length;i++){
                        if(this.selectRow[i].isDelete){
                            arr.push(this.selectRow[i].id)
                        }else{
                            this.tip("请选择数据有不可删除项","warning")
                            return;
                        }
                    }
                    this.del(arr)
                }
            },
            del(ids){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/return.delete",{ids:ids},()=>{
                        this.tip('删除成功','success');
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            confirmRefuseRemark(){
                this.$confirm('是否确认拒绝?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let arr = new Array();
                    if(this.batchOrSingle==1){
                        arr.push(this.form_params.id)
                        this.refuse.ids=arr;
                    }else if(this.batchOrSingle==2){
                        this.selectRow.forEach(item=>{
                            arr.push(item.id)
                        })
                        this.refuse.ids=arr;
                    }else{
                        return;
                    }
                    this.postFuncLoading("/erp/return.refuse",this.refuse,()=>{
                        this.tip('操作成功','success');
                        this.dialogVisible=false;
                        this.centerDialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            batch(type){
                if(this.selectRow.length<=0){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    if(type==1){
                        this.pass(arr)
                    }else if(type==2){
                        this.centerDialogVisible=true;
                        this.batchOrSingle=2;
                        // this.confirmRefuseRemark(arr)
                    }
                }
            },
            pass(ids){
                this.$confirm('是否确认通过?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/return.pass",{ids:ids},()=>{
                        this.tip('操作成功','success');
                        this.dialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            reset(){
                this.start_time="";
                this.end_time=new Date();
                this.params={search:{start_time:"",end_time:"",customer_id:"",sn:"",brand_id:"",breed_id:"",bale_no:"",warehouse_id:"",status:"",},page:1,per_page:50}
                this.$refs['selectdowncustomer'].clearData();
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.start_time=this.formatTimeZero(this.start_time);
                this.params.search.end_time=this.formatTimeZero(this.end_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/return.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.list;
                    this.list.forEach((item,index)=>{
                        item.isEdit = false;
                        if(item.return_time!=0){
                            this.list[index].return_time = this.formatTime(item.return_time+"000")
                        }else{
                            this.list[index].return_time = "";
                        }
                        this.list[index].sales_cube = this.keepLimit(this.list[index].sales_cube)
                        this.list[index].out_cube = this.keepLimit(this.list[index].out_cube)
                        this.list[index].return_cube = this.keepLimit(this.list[index].return_cube)
                        this.list[index].sales_amount = this.keepPrice(this.list[index].sales_amount)
                        this.list[index].return_amount = this.keepPrice(this.list[index].return_amount)
                    })
                    this.filter = res.data.data.column;
                    this.copy_filter = JSON.parse(JSON.stringify(res.data.data.column))
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_str"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            getTableDelete(id){
                this.del([id])
            },
            rowClick(obj){
                this.scene = 'return.details';
                this.isGlobal = true;
                this.getBillColumn();
                this.postFunc("/erp/return.detail",{id:obj.id},res=>{
                    this.form_params=res.data.data;
                    this.isEdit = this.form_params.isEdit;
                    this.newFee = this.form_params.fee_list;
                    if(this.form_params.rec==1){
                        this.form_params.rec = true
                    }
                    this.tableTotal.totalPrice = this.form_params.return_amount;
                    this.tableTotal.tax_amount = this.form_params.tax_amount;
                    this.tableTotal.refundableAmount = this.form_params.refund_pay_amount;
                    this.form_params.details.forEach((item,index) => {
                        this.form_params.details[index].return_cube=this.keepLimit(this.form_params.details[index].return_cube)
                        this.form_params.details[index].sales_cube=this.keepLimit(this.form_params.details[index].sales_cube)
                        this.form_params.details[index].out_cube=this.keepLimit(this.form_params.details[index].out_cube)
                        this.form_params.details[index].sales_price=this.keepPrice(this.form_params.details[index].sales_price)
                        this.form_params.details[index].totalPrice=this.keepPrice(Number(this.form_params.details[index].sales_price)*Number(this.form_params.details[index].sales_cube))
                    });
                    this.dialogVisible=true;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            amend(){
                this.calcTaxAmount();
                this.recChanges = !this.recChanges;
                this.f_rec = this.form_params.rec;
                this.rec_params.id = this.form_params.id;
                this.rec_params.rec_type = this.form_params.rec_type;
                this.rec_params.tax_rate = this.form_params.tax_rate;
            },
            settlementConfirm(){
                this.rec_params.rec = this.f_rec
                this.rec_params.rec = this.rec_params.rec==true?1:0;
                this.rec_params.remark = this.form_params.remark;
                this.postFuncLoading('/erp/return.update',this.rec_params,()=>{
                    this.outRecChanges();
                    this.tip("修改成功", "success");
                    let params = {name:"order_return_sn",id:this.form_params.id};
                    this.rowClick(params)
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            outRecChanges(){
                this.rec_params.remark =''
                this.recChanges = false;
            },
            //计算合计
            calcTaxAmount(){

            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            getRow(row){
                this.selectRow=row;
            },
            toggleSelection(row) {
                this.$refs.outBoundDetailTable.toggleRowSelection(row);
            },
        },
        components:{
            tabletem,
            pagination,
            selectDownCustomer
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialogVisible":function(val){
                if(!val){
                    this.form_params="";
                }
            },
            "centerDialogVisible":function(val){
                if(!val){
                    this.refuse=this.resetJson(this.refuse)
                }
            },
            "f_rec": function () {
                this.calcTaxAmount();
            },
            "rec_params.rec_type": function () {
                this.calcTaxAmount();
            },
            "rec_params.tax_rate": function () {
                this.calcTaxAmount();
            },
        }
    }
</script>
<style scoped lang="scss">
    // dialog START
    .sizefh{font-size: 13px;padding: 5px 0;}
    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:25%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;position: relative;align-items: center;justify-items: center;display: flex;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    // dialog END
    .remarkBoxFourText{padding:5px 5px 5px 70px;}
    .remarkBoxFourText:before{content:"退货原因:";color: #606266;}
    .recMess{
        display: flex;
        .recCom{flex: 1;display: flex;align-items: center;justify-items: center;display: flex;}
    }
    .form_edits{width:20px;cursor: pointer;}  
    .taxDiv{
        margin-left: 12px;
    }
    .taxDiv /deep/ {
        display: flex;
        .taxCheck{
            z-index: 11;
        }
        .taxTypeSelect{
            width: 40px;
            // position: absolute;
            // left: 20px;
            // top: 1px;
            // z-index: 9;
            .el-input__inner{
                padding-right: 0;
                padding-left: 5px;
                font-size: 14px;
                border-right: none;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                height: 25px;
            }
            .el-select__caret{
                font-size: 10px;
                position: relative;
                left: 10px;
            }
        }
        .taxInput{
            width: 120px;
            .el-input__inner{
                padding-left: 10px;
                padding-right: 15px;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                height: 25px;
            }
        }
        .taxSpan{
            color: red;
        }
    }
</style>
